// Helper function to get the selected value of a variant option
function getSelectedVariantValue(optionName) {
    const variantContainer = document.querySelector(`[data-variant-name="${optionName}"]`);
    if (!variantContainer) {
        return null;
    }
    const selectedInput = variantContainer.querySelector('input[type="radio"]:checked');
    return selectedInput?.dataset.variantValue || null;
}

// Helper function to normalize strings
function normalizeString(str) {
    return str.trim().replace(/[\u200B-\u200D\uFEFF]/g, "");
}

// Helper function to get available options for a given size
function getAvailableOptionsForSize(product, selectedSize) {
    return product.variants
        .filter(variant => variant.option1 === selectedSize)
        .map(variant => variant.option2);
}

// Function to hide unavailable variant options
window.hideUnavailableVariants = function hideUnavailableVariants(variantData, product) {
    const sizeVariantName = product.options[0];
    const lengthVariantName = product.options[1];
    const lengthContainer = document.querySelector(`[data-variant-name="${lengthVariantName}"]`);
    const countLength = Object.keys(variantData).length;

    const selectedSize = getSelectedVariantValue(sizeVariantName);

    if (!selectedSize || !lengthContainer) return;

    const availableOptions = getAvailableOptionsForSize(product, selectedSize).map(normalizeString);

    lengthContainer.querySelectorAll('label[data-variant-value]').forEach(element => {
        const variantValue = normalizeString(element.getAttribute('data-variant-value'));
        const isAvailable = availableOptions.includes(variantValue);

        if (!variantData[variantValue] || !isAvailable) {
            element.classList.add('hidden');
        } else {
            element.classList.remove('hidden');
        }
    });

    lengthContainer.classList.toggle('hidden', countLength < 2);
};

// Function to auto-select the available variant based on the current selection
window.autoSelectVariant = function autoSelectVariant(product) {
    const sizeVariantName = product.options[0];
    const lengthVariantName = product.options[1];
    const lengthContainer = document.querySelector(`[data-variant-name="${lengthVariantName}"]`);

    const selectedSize = getSelectedVariantValue(sizeVariantName);
    const selectedLength = getSelectedVariantValue(lengthVariantName);

    if (!selectedSize || !lengthContainer) return;

    const variantAvailable = product.variants.some(variant =>
        variant.options[0] === selectedSize &&
        variant.options[1] === selectedLength &&
        variant.available
    );

    if (!variantAvailable) {
        const newVariant = product.variants.find(variant =>
            variant.options[0] === selectedSize &&
            variant.available
        );
        if (newVariant) {
            const newVariantOption = normalizeString(newVariant.options[1]);

            // Find the correct input by iterating over elements
            const newVariantInput = Array.from(lengthContainer.querySelectorAll('[data-variant-value]')).find(input => {
                const variantValue = input.getAttribute('data-variant-value');
                return normalizeString(variantValue) === newVariantOption;
            });

            newVariantInput?.click();
        }
    }
};
